<div id="webvoucher" class="webvoucher-container ya-typography">
  <ya-subheader [hasContent]="true">

  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--padding">
    <div class="webvoucher-content-wrapper">
      <div class="create-voucher-description">
        <h2 langkey="phWebVoucher_CreateVoucher_Title"></h2>
        <p langkey="phWebVoucher_CreateVoucher_Description"></p>
      </div>
      <div class="ya-webshop-button-container continue-button">
        <button mat-flat-button (click)="createWebVoucherCode()"><span
            langkey="phWebvoucher_CreateVoucher_Button"></span></button>
      </div>
      <mat-divider></mat-divider>
      <div class="enter-voucher-description">
        <h2 langkey="phWebvoucher_EnterCode_Title"></h2>
        <p langkey="phWebvoucher_EnterCode_Description"></p>
      </div>
      <div class="webvoucher-form">
        <form #webvoucherForm="ngForm">
          <!-- <div class="webvoucher-form-Wrapper"> -->
          <div class="ya-input-container">
            <div class="ya-input-wrapper">
              <div class="input-text">
                <input a11y_SpinButton numericInput id="webvoucherCode" name="webvoucherCode"
                  #webvoucherCodeInput="ngModel" [(ngModel)]="webvoucherCode" (focus)="handleFocusEvent()"
                  (blur)="handleBlurEvent()" type="tel" class="ya-input-text" minlength="18" maxlength="18"
                  [placeholder]="getQRCodePalceHolder()" required>
              </div>
              <div class="ya-error-validaton-container"
                [ngClass]="webvoucherCodeInput.invalid && webvoucherCodeInput.touched ? 'ya-input-invalid':''">
                <div class="ya-error-validation">
                  <div class="error-validation-icon">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-close"></div>
                  </div>
                  <div class="error-validation-text ya-caption">
                    <span langkey="phWebvoucher_Validate_Code"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="webvoucherForm.valid ; then enableedButtonTemplate else disabledButtonTemplate">
            </ng-container>
            <ng-template #enableedButtonTemplate>
              <button mat-flat-button [ngClass]="'mat-flat-button ya-body-1'" (click)="setWebvoucherCode()">
                <span class=" ya-body-1" langkey="phWebvoucher_button_continue"></span>
              </button>
            </ng-template>
            <ng-template #disabledButtonTemplate>
              <span (click)="disabledWebvoucherButtonClick()">
                <button mat-flat-button [ngClass]="'mat-flat-button  ya-body-1'" disabled>
                  <span class=" ya-body-1" langkey="phWebvoucher_button_continue"></span>
                </button>
              </span>
            </ng-template>
            <!-- <ng-container *ngIf="webshopServiceWebvoucherActive">
                <button mat-flat-button [ngClass]="'mat-flat-button ya-body-1'" (click)="navigateToShop()">
                  <span class=" ya-body-1" langkey="phWebvoucher_button_ToShop"></span>
                </button>
              </ng-container> -->
          </div>
          <div class="webvoucher-failed ya-caption">
            <span>{{webvoucherFailedMessage}}</span>
          </div>
          <!-- </div> -->
        </form>
      </div>
    </div>
  </div>
</div>